module.exports = __webpack_public_path__ + "media/images/flags/4x3/col-616fbe2fae4eb8eb925037b151941094.svg";